export const returnPath = ({ search, pathname } = {}) =>
  search ? `${pathname}?${search}` : pathname;
